import { EnglishProficiencyQuestionKind } from 'generated/graphql';
import { TEnglishProficiencyQuestion } from './EnglishProficiencyTest.helpers';

/**
 * The two practice items, one of each kind.
 *
 * Written here rather than fetched: a practice run has no sitting behind it,
 * so there is nothing to fetch from and nothing to record. Two items is the
 * whole point — there is one of each kind to meet, and a practice long enough
 * to be a chore is one candidates skip.
 *
 * Deliberately **not** in the translation files. The real bank is a fixed
 * English-only form served from S3, and its question text arrives in English
 * whatever the candidate reads the portal in. A translated practice item would
 * rehearse something the test never asks. They are far easier than anything in
 * the bank, for the same reason: this teaches the controls, not the language.
 *
 * `category` and `tags` are never rendered, but the type carries them and the
 * shape has to match a real item exactly — the practice page is the real page.
 */
export const ENGLISH_PROFICIENCY_PRACTICE_QUESTIONS: TEnglishProficiencyQuestion[] =
  [
    {
      __typename: 'EnglishProficiencyMultipleChoiceQuestion',
      index: 1,
      kind: EnglishProficiencyQuestionKind.MultipleChoice,
      text: 'My brother <blank> a doctor.',
      instructions: 'Choose one correct answer.',
      category: 'Practice',
      tags: [],
      passage: null,
      asset: null,
      answers: [
        { __typename: 'EnglishProficiencyAnswerOption', index: 0, text: 'be' },
        { __typename: 'EnglishProficiencyAnswerOption', index: 1, text: 'is' },
        { __typename: 'EnglishProficiencyAnswerOption', index: 2, text: 'are' },
        {
          __typename: 'EnglishProficiencyAnswerOption',
          index: 3,
          text: 'being',
        },
      ],
    },
    {
      __typename: 'EnglishProficiencyShortAnswerQuestion',
      index: 2,
      kind: EnglishProficiencyQuestionKind.ShortAnswer,
      text: 'The opposite of "hot" is <blank>.',
      instructions: 'Type the missing word below.',
      category: 'Practice',
      tags: [],
      passage: null,
      asset: null,
      blankCount: 1,
      clue: 'The first letter is "c"',
    },
  ] as unknown as TEnglishProficiencyQuestion[];
